import * as Mui from '@material-ui/core';
var Chip = Mui.Chip;
export default Chip;
//# sourceMappingURL=index.js.map